import type { TopFullBannerStyles } from '~/features/top-full-banner';
import { tw } from '~/utils';

export const topFullBannerStyles = tw<TopFullBannerStyles>({
  box: 'block w-full',
  img: 'w-full',
});
